import { ShowcaseStoriesEffects } from './showcase-stories.effects';

export const showcaseStoriesEffects = [ShowcaseStoriesEffects];
